export const name = 'pageRecordPreviewZoominDirective';
export default function pageRecordPreviewZoominDirective() {
//noinspection BadExpressionStatementJS
    'ngInject';

    var directive = {
        restrict: 'E',
        template: require('./pageRecordPreviewZoomin.html'),
        scope: {

        },

        controller: pageRecordPreviewZoominController,
        controllerAs: 'vm',
        bindToController: true
    };

    return directive;
}


function pageRecordPreviewZoominController($q, $scope, stateKeeperService, $stateParams, breadCrumbsCreatorFactory, ImageUrlCreatorFactory,
                                           CachingFactory, $interval, templatesService, $window, breadcrumbsService) {
    //noinspection BadExpressionStatementJS
    'ngInject';

    var vm = this;
    vm.pageTitle = null;
    vm.isInitializationComplete = true;
    vm.assetsLibStorageIds = null;
    vm.composerTemplateId = null;
    vm.dataStorageId = null;
    vm.templateName = null;
    vm.dataFileName = null;
    vm.imageSource = null;
    vm.totalPages = null;
    vm.totalRecords = null;
    vm.cache = null;
    vm.headers = null;

    vm.pageNumber = 1;
    vm.recordNumber = 1;

    vm.onPlus = onPlus;
    vm.plusDisabled = true;

    vm.onMinus = onMinus;
    vm.minusDisabled = true;

    vm.fitToPage = fitToPage;
    vm.fitToPageDisabled = true;

    vm.rotatePage = rotatePage;
    vm.rotateDisabled = true;

    vm.triggerZoomIn = false;
    vm.triggerZoomOut = false;
    vm.reset = false;
    vm.rotate = 0;

    vm.onImageRetry = onImageRetry;

    vm.onRecordsNavigatorChange = onRecordsNavigatorChange;
    vm.onPagesNavigatorChange = onPagesNavigatorChange;

    vm.onImageLoaded = onImageLoaded;

    vm.onZoomChange = onZoomChange;

    let stateParams = angular.copy($stateParams);

    initialize();

    function initialize(){

        breadcrumbsService.isBreadcrumbsFeatureEnabled().then(isNewBreadcrumbsActivated => {
          if(!isNewBreadcrumbsActivated) {
            vm.breadcrumbs = breadCrumbsCreatorFactory.createBreadCrumbs();
          }
        });

        if(stateParams.data) {
          setStateParams();

          vm.totalRecords = vm.data.length;

          if (vm.dataFileName === null || vm.dataFileName === undefined || vm.dataFileName === 'null') {
            vm.pageTitle = vm.templateName + ".pdf";
          } else {
            vm.pageTitle = vm.templateName + vm.dataFileName + ".pdf";
          }

          if(vm.cache === null) {
            vm.cache = CachingFactory.createCachingObject();
            createCurrentImage();
          }else{
            let cacheEntry = getCachingEntry(vm.recordNumber);

            if(cacheEntry !== undefined && cacheEntry.state === "successful") {
              // might be that the image was already created in the past - in that case switch to it
              vm.imageSource = extractImageUrlFromImageRequestResult(getCachingEntry(vm.recordNumber).url);
            }
          }
        }
    }

    function setStateParams(){
        vm.composerTemplateId = stateParams.composerTemplateId;
        vm.data = stateParams.data;
        vm.templateName = stateParams.templateName;
        vm.dataFileName = decodeURIComponent(stateParams.dataFileName);
        vm.totalPages = stateParams.totalPages;
        vm.recordNumber = stateParams.recordNumber;
        vm.pageNumber = stateParams.pageNumber;
        vm.headers = stateParams.headers;
        vm.assetsLibStorageIds = stateParams.assetsLibrariesStorageIds;
    }

    function createCurrentImage(){
        vm.imageSource = null;

        let defer = $q.defer();

        ImageUrlCreatorFactory.createImage(vm.cache, getCurrentCachingIndex(), {
                 pageNumber:vm.pageNumber, recordNumber:vm.recordNumber} ,function() {
                return requestPageRecordImage(vm.pageNumber, vm.recordNumber);
            },
            function(_cachingIndex, identity){
                if(identity.pageNumber === vm.pageNumber && identity.recordNumber === vm.recordNumber){
                    vm.imageSource = extractImageUrlFromImageRequestResult(getCachingEntry(_cachingIndex).url);
                }
                defer.resolve(getCachingEntry(_cachingIndex).url);
            },
            function(_cachingIndex, identity){
                if(identity.pageNumber === vm.pageNumber && identity.recordNumber === vm.recordNumber){
                    vm.imageSource = "error"; // "error" url
                }

                defer.reject();
            });

        return defer.promise;
    }


    function requestPageRecordImage(pageNumber, recordNumber){
        let cells = [{
            page:pageNumber - 1,
            recordData:vm.data[recordNumber - 1],
            record: recordNumber - 1
        }];

        return templatesService.fetchCacheWithEmbeddedDataRequest(vm.composerTemplateId, vm.headers, cells, vm.assetsLibStorageIds,true);
    }


    function extractImageUrlFromImageRequestResult(imageRequestResult){
        return imageRequestResult[0].storageId;
    }

    function getCurrentCachingIndex(){
        return (vm.recordNumber - 1)*vm.totalPages + vm.pageNumber;
    }

    function getCachingEntry(cachingIndex){
        return vm.cache.get(cachingIndex);
    }


    function onPlus(){
        vm.triggerZoomIn = true;
    }

    function onMinus(){
        vm.triggerZoomOut = true;
    }

    function fitToPage(){
        vm.reset = true;
    }

    function rotatePage(){
        let newRotation = vm.rotate;
        newRotation += 90;
        if(newRotation === 360){
            newRotation = 0;
        }
        vm.rotate = newRotation;
    }

    function onZoomChange(zoomLevel){
        if(zoomLevel === 100){
            vm.minusDisabled = true;
            vm.plusDisabled = false;
        }else{
            vm.minusDisabled = false;
            vm.plusDisabled = false;
        }
    }

    function onImageRetry(){
        onPagesNavigatorChange(null, null);
    }

    function onRecordsNavigatorChange(current){
        onPagesNavigatorChange(null, current);
    }

    function onPagesNavigatorChange(current, record = null){
        vm.imageSource = null;
        if(current !== null){
            vm.pageNumber = current;
        }else{
            current = vm.pageNumber;
        }


        vm.fitToPageDisabled = true;
        vm.rotateDisabled = true;
        vm.minusDisabled = true;
        vm.plusDisabled = true;

        if(record == null){
            record = vm.recordNumber;
        }else{
            vm.recordNumber = record;
        }


        // wait for a second as it might be that user is only passing through
        $interval(function(){
            // we are still at the same one selected by user
            if(vm.pageNumber === current && vm.recordNumber === record){
                let cachingIndex = getCurrentCachingIndex();
                let cacheEntry = getCachingEntry(cachingIndex);

                if(cacheEntry !== undefined && cacheEntry.state === "successful"){
                    // might be that the image was already created in the past - in that case switch to it
                    vm.imageSource = extractImageUrlFromImageRequestResult(getCachingEntry(cachingIndex).url);
                }else if(cacheEntry === undefined || cacheEntry.state === "error"){
                    // in case the image was never requested or, in case it was requested but returned with error in the past - then request it
                    createCurrentImage();
                }else{
                    // if we are here then it means that the entry is defined, and the status is requested - in this case just wait for it - set the image to null
                    vm.imageSource = null;
                }
            }

        },1000,1);
    }

    function onImageLoaded(){
        vm.fitToPageDisabled = false;
        vm.rotateDisabled = false;
        vm.minusDisabled = true;
        vm.plusDisabled = false;
    }

    // check occupied space and how left for the image zoom in

    vm.isPageLoaded = false;
    let pageParentElement = angular.element(document.getElementById("composer-page-zoom-in-view-page"));

    let AllInternalPageElementIds = [
        'composer-page-zoom-in-view-page-toolbar',
        "composer-page-zoom-in-view-page-nav1",
        "composer-page-zoom-in-view-page-nav1-txt",
        "composer-page-zoom-in-view-page-nav2",
        "composer-page-zoom-in-view-page-nav2-txt"
    ];

    let upperRibbonSpace = 0;
    let upperRibbon = document.getElementById('upper-ribbon-wrapper');
    if(upperRibbon !== null){
      upperRibbonSpace = upperRibbon.getBoundingClientRect().height + 10;
    }

    $interval(function(){
        if(pageParentElement.children().length === AllInternalPageElementIds.length){
            let totalHeight =  pageParentElement[0].getBoundingClientRect().height;
            let subAndStatus = getElementsHeightSum(AllInternalPageElementIds);
            if(subAndStatus.isAllLoaded){
                vm.nonAvailableSpaceForPreview = subAndStatus.sum + ($window.innerHeight - totalHeight) + upperRibbonSpace + 20;
                vm.isPageLoaded = true;
            }
        }
    },500,0);

    function getElementsHeightSum(elementIds){
        let sum = 0;
        let isAllNotZero = true;
        for(let iElement = 0; iElement < elementIds.length; iElement++){
            let element =  angular.element(document.getElementById(elementIds[iElement]));
            if(element !== undefined && element !== null && element[0] !== undefined && element[0] !== null){
                let elementHeight = element[0].getBoundingClientRect().height;
                sum += elementHeight;
                if(elementHeight === 0){
                    isAllNotZero = false;
                }
            }else{
                isAllNotZero = false;
            }
        }
        return {sum:sum, isAllLoaded:isAllNotZero};
    }

    $scope.$on('$stateChangeStart', function (ev, to, toParams, from, fromParams) {
      //assign the "from" parameter to something
      if(from.name === 'templates.templatedetails.pagepreview') {
        let stateToKeep = {
          stateParams: stateParams,
          recordNumber: vm.recordNumber,
          pageNumber: vm.pageNumber,
          cache: vm.cache
        };
        stateKeeperService.keepState('templates.templatedetails.pagepreview', stateToKeep);
      }
    });

    $scope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
      //assign the "from" parameter to something
      if(!$stateParams.data) {
        let stateToRestore = stateKeeperService.getState('templates.templatedetails.pagepreview');
        stateParams = stateToRestore.stateParams;
        stateParams.recordNumber = stateToRestore.recordNumber;
        stateParams.pageNumber = stateToRestore.pageNumber;
        vm.cache = stateToRestore.cache;
        initialize();
      }
    });
}

